import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * FileViewer — opens a presentation file in a new tab.
 * Fetches with auth, then renders the file directly (PDF, image) or triggers download.
 * Route: /file/:fileId
 */
const FileViewer = () => {
  const { fileId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, error
  const [error, setError] = useState('');

  useEffect(() => {
    const loadFile = async () => {
      const token = localStorage.getItem('authToken');
      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const res = await fetch(`/api/cards/presentation-files/${fileId}/download`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (!res.ok) {
          if (res.status === 401) { navigate('/login'); return; }
          if (res.status === 403) { setError('You do not have access to this file.'); setStatus('error'); return; }
          if (res.status === 404) { setError('File not found.'); setStatus('error'); return; }
          setError('Failed to load file.'); setStatus('error'); return;
        }

        const contentType = res.headers.get('content-type') || '';
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);

        // Replace the current page with the file content
        window.location.replace(url);
      } catch (err) {
        setError('Failed to load file.');
        setStatus('error');
      }
    };

    loadFile();
  }, [fileId]);

  if (status === 'error') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-sm text-center">
          <svg className="w-12 h-12 text-red-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>
          <p className="text-sm text-gray-700 font-medium">{error}</p>
          <button onClick={() => window.close()} className="mt-4 px-4 py-2 text-xs bg-gray-800 text-white rounded-lg hover:bg-gray-900">Close Tab</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-3 text-sm text-gray-500">Opening file...</p>
      </div>
    </div>
  );
};

export default FileViewer;
